<template>
	<el-drawer
		:visible="true"
		@close="goBack"
		style="border-radius: 0 25px 0 25px"
		direction="rtl"
		:with-header="false"
		size="80%"
	>
		<div v-if="school">
			<div class="drawer-header">
				<span class="title">{{ school.name.String }}</span>

				<div style="margin: auto 0 auto auto">
					<md-button class="md-icon-button" @click="goBack">
						<md-icon style="color: white">close</md-icon>
					</md-button>
				</div>
			</div>
			<div class="drawer-body" :key="school.id">
				<div class="container-tab">
					<div
						v-for="(tb, $index) in tabs"
						:key="$index"
						:class="{ 'tab-effect': tab !== $index }"
						class="tab"
						@click="tab = $index"
					>
						<span :class="{ 'tab-selected': tab === $index }">{{ $t(tb.translationKey) }}</span>
					</div>
				</div>

				<div style="width: 100%">
					<!-- BIO INFOMATIONS -->
					<div v-if="tab == 0" class="page" :style="{ height: height + 'px' }">
						<div class="info-header">
							<el-image v-loading="image_src == undefined" :src="image_src" style="" />
							<div v-if="tab < 2" style="align-items: center; display: flex">
								<option-button
									:show="true"
									:buttons="buttons"
									@save="handleSave"
									@clear="handleClear"
									@archive="handleArchive"
									@restore="handleRestore"
									@chat="handleChat"
									@confirm="
										() => {
											resendMail(item)
										}
									"
									@manualconfirm="handleConfirmSchool"
								/>
							</div>
						</div>

						<div v-if="school.request_of_deletion" style="display: flex">
							<h4 style="color: red">{{ $t("request-oblivion-admin") }}</h4>
							<el-button @click="Nuke()" type="danger" style="margin: 10px"
								><img style="width: 30px" src="/bomb.png"
							/></el-button>
						</div>

						<school-main-form
							:element="element"
							:error="error"
							:clear="edit == undefined ? undefined : !edit"
							@edit="value => (edit = value)"
						/>
						<div style="width: 100%">
							<div class="data-item">
								<div class="label">
									<strong>{{ $t("created-at") }}</strong>
								</div>
								<div class="value">
									<span v-if="element">{{ moment(element.created_at).format("DD-MM-YYYY") }}</span>
								</div>
							</div>
							<div class="data-item">
								<div class="label">
									<strong>{{ $t("updated-at") }}</strong>
								</div>
								<div class="value">
									<span v-if="element">{{ moment(element.updated_at).format("DD-MM-YYYY") }}</span>
								</div>
							</div>
							<div class="data-item" v-if="element && element.deleted_at">
								<div class="label">
									<strong>{{ $t("deleted-at") }}</strong>
								</div>
								<div class="value">
									<span>{{
										element.deleted_at ? moment(element.deleted_at).format("DD-MM-YYYY") : ""
									}}</span>
								</div>
							</div>
						</div>
					</div>
					<!-- OTHER INFOMATIONS -->
					<div v-if="tab == 1" class="page" :style="{ height: height + 'px' }">
						<div class="info-header">
							<el-image v-loading="image_src == undefined" :src="image_src" style="" />
							<div v-if="tab < 2" style="align-items: center; display: flex">
								<option-button
									:show="true"
									:buttons="buttons"
									@save="handleSave"
									@clear="handleClear"
									@archive="handleArchive"
									@restore="handleRestore"
								/>
								<!--									@archive="doMutation({ element: 'deleting', value: true })"-->
								<!--									@restore="doMutation({ element: 'restoring', value: true })"-->
							</div>
						</div>
						<school-secondary-form
							:element="element"
							@edit="value => (edit = value)"
							:clear="edit == undefined ? undefined : !edit"
						/>
					</div>
					<!-- SCHOOL's USER -->
					<div v-if="tab == 2" class="page" style="display: flex" :style="{ height: height - 15 + 'px' }">
						<school-users-table :element="element" />
					</div>
					<!-- SUBSCRIPTIONS -->
					<div v-if="tab == 3" class="page" :style="{ height: height + 'px' }">
						<organization-subscriptions
							:school="element"
							:clear="edit == undefined ? undefined : !edit"
							@edit="edit = true"
						/>
					</div>
					<!-- COMUINICATIONS -->
				</div>
			</div>
		</div>
	</el-drawer>
</template>

<script>
import axios from "axios"
import { mapActions, mapGetters } from "vuex"
import SchoolUsersTable from "@/modules/organization/form-component/school-users-table.vue"
import SchoolMainForm from "@/modules/organization/form-component/school-main-form.vue"
import SchoolSecondaryForm from "@/modules/organization/form-component/school-secondary-form.vue"
import OptionButton from "@/modules/_common/button/option-button.vue"
import OrganizationSubscriptions from "@/modules/organization/form-component/organization-subscriptions.vue"
import PaymentsTable from "../../payments/payments-components/form/payments-table.vue"

export default {
	name: "schools-details",
	components: {
		SchoolMainForm,
		SchoolUsersTable,
		SchoolSecondaryForm,
		OptionButton,
		OrganizationSubscriptions,
		PaymentsTable
	},
	data() {
		return {
			height: window.innerHeight - 150,
			tabs: [
				{ translationKey: "bio-informations" },
				{ translationKey: "other-informations" },
				{ translationKey: "users" },
				{ translationKey: "subscriptions" }
				// { translationKey: "communication" }
			],
			tab: 0,
			element: undefined,
			error: [],
			edit: undefined,
			buttons: [],
			image_src: undefined
		}
	},
	watch: {
		school: function () {
			this.element = {
				...this.school,
				name: this.school.name.String
			}

			if (this.school.deleted_at) this.buttons = ["chat", "restore"]
			else this.buttons = ["chat", "archive"]

			if (!this.element.confirmed) {
				this.buttons.push("confirm", "sendagain")
			}

			if (this.school) {
				this.doImage()
			}
		},
		edit: function () {
			if (this.element == undefined) return
			if (this.edit) {
				this.buttons = ["save", "clear"]
			} else {
				this.buttons = ["chat"]
				if (this.element.deleted_at) this.buttons.push("restore")
				else this.buttons.push("archive")
			}
			if (!this.element.confirmed) {
				this.buttons.push("confirm")
			}
		},
		img_uploaded: function () {
			this.doImage()
		}
	},

	async created() {
		this.edit = false
		if (this.$route.params.school_id) {
			this.$nextTick(async () => {
				await this.doSchoolGetById(this.$route.params.school_id)
			})
		}

		this.element = {
			...this.school
		}
	},

	computed: {
		...mapGetters({
			school: "school/school",
			deleting: "organization/deleting",
			img_uploaded: "organization/img_uploaded"
		})
	},

	methods: {
		Nuke() {
			this.$confirm(this.$t("are-you-sure-to-perm-delete-admin"), this.$t("warning"), {
				confirmButtonText: "OK",
				cancelButtonText: this.$t("cancel"),
				type: "danger"
			})
				.then(() => {
					this.$confirm(this.$t("are-you-sure-to-perm-delete-admin-2"), this.$t("warning"), {
						confirmButtonText: "OK",
						cancelButtonText: this.$t("cancel"),
						type: "danger"
					})
						.then(() => {
							axios
								.post(
									process.env.VUE_APP_API_URL + "/api/user/NUKE",
									{
										id: this.school.id
									},
									{ headers: { Authorization: "Bearer " + localStorage.getItem("JWT") } }
								)
								.then(res => {
									this.$notification("success", this.$t("oblivion-success-admin"), "", 4500)
								})
								.catch(err => {
									this.$notification("error", this.$t("oblivion-error-admin"), "", 0)
								})
						})
						.catch(() => {})
				})
				.catch(() => {})
		},
		...mapActions({
			saveCustomField: "organization/saveCustomField",
			doMutation: "school/doMutate",
			doArchive: "school/doArchive",
			doRestore: "school/doRestore",
			doSchoolGetById: "school/doSchoolGetById",
			insertTicket: "ticketing/insertTicket"
		}),
		goBack: function () {
			this.$router.replace({ path: "/users/schools" })
		},

		handleClear: function () {
			this.edit = false
			this.error = []
			this.element = {
				...this.school,
				name: this.school.name.String
			}
		},

		handleConfirmSchool: function () {
			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/organizations/confirm",
					{
						confirmation_code: this.school.confirmation_code.String
					},
					{
						headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
					}
				)
				.then(res => {
					this.$notification("success", this.$t("confirm-success"), "", 4000)
				})
				.catch(err => this.$notification("error", this.$t("confirm-error"), "", 0))
		},

		async handleSave() {
			await this.saveCustomField({ id: this.school.id, tab: this.tab })
			this.edit = undefined
			this.tab = 0
			this.$emit("update")
		},
		async handleChat() {
			this.insertTicket({ title: "Nuova comunicazione da admin", organizationId: this.school.id }).then(res => {
				this.$goTo("/ticketing/" + res)
			})
		},

		async handleArchive() {
			this.doMutation({ element: "deleting", value: true })
			await this.doArchive(this.school)
			this.$notification("success", this.$t("archive-success"), "", 4000)
			this.goBack()
		},

		async handleRestore() {
			this.doMutation({ element: "restoring", value: true })
			await this.doRestore(this.school)
			this.$notification("success", this.$t("restored-successfully"), "", 4000)
			this.goBack()
		},

		reset: function () {
			this.edit = false
			this.error = []
			this.element = undefined
			this.tab = 0
		},
		resendMail: function () {
			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/organizations/resendemail",
					{
						id: this.element.id,
						language: localStorage.getItem("lang")
					},
					{
						headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
					}
				)
				.then(res => {
					if (res.data) {
						this.$notification("success", this.$t("sent-email"), "", 4000)
					} else {
						this.$notification("error", this.$t("error-email"), "", 0)
					}
				})
				.catch(err => this.$notification("error", this.$t("error-email"), "", 0))
		},
		doImage() {
			const payload = {
				custom_field_name: "logo scuola",
				owner_type: "organizations",
				owner_id: this.school.id,
				organization_id: this.school.id
			}
			this.image_src = undefined

			axios
				.post(process.env.VUE_APP_API_URL + "/api/customfieldvalues/getImage", payload, {
					headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
				})
				.then(({ data: { file } }) => (file ? (this.image_src = `data:image/png;base64,${file}`) : ""))
				.catch(err => console.error(err))
		}
	}
}
</script>
<style scoped lang="scss">
@import "src/assets/scss/my-tab";
@import "src/assets/scss/my-form";
@import "src/assets/scss/my-drawer";

.page {
	overflow-y: auto;
	width: 95%;
	margin-left: auto;
	margin-right: auto;
	padding: 10px;
}

.info-header {
	display: flex;
	margin-bottom: 50px;

	.el-image {
		width: 150px;
		height: 150px;
		margin: auto;
	}
}
</style>
